module.exports = __webpack_public_path__ + "static/mstile-310x310-c2c4d255ec8e80bad9e6649d8d02e506.png";